import { computed } from '@nuxtjs/composition-api';
import { PartsDbVehicleSummary } from '@unified-commerce/gpc-vue-storefront-parts-db';
import {
  useVehicleSearch,
  VehicleSearchOptions,
} from '@unified-commerce/gpc-vue-storefront-search';

const useOriginalVehicleSearch = () => {
  const {
    search,
    result,
    loading,
    error: vehicleSearchError,
  } = useVehicleSearch('original-vehicle-search');

  const getVehicleIds = (vehicleResults: typeof result) => {
    const vehicleHits = (vehicleResults.value.results ?? []).flatMap((result) => result.hits);

    return vehicleHits
      .map((hit) => {
        if (hit.MapToVehicleID) {
          return hit.MapToVehicleID;
        }

        if (hit.Hidden) {
          return null;
        }

        return hit.VehicleID;
      })
      .filter((id): id is string => id !== null);
  };

  const searchOriginalVehicles = async (vehicleSummaries: PartsDbVehicleSummary[]) => {
    const vehicleIds = vehicleSummaries.map((vehicle) => vehicle.vehicleId);

    const vehicleFilters = vehicleIds.map((v) => `VehicleID:${v}`).join(' OR ');

    const searchOptions: VehicleSearchOptions = {
      resultsPerPage: vehicleIds.length,
      filters: vehicleFilters,
    };

    await search(searchOptions);

    const originalVehicleIds = getVehicleIds(result);

    return {
      originalVehicleIds,
    };
  };

  const error = computed(() => vehicleSearchError.value.search);

  return {
    loading,
    searchOriginalVehicles,
    error,
  };
};

export default useOriginalVehicleSearch;
